import { useState, useEffect, useContext } from "react";
import BillingsPage from "./Billings";
// import PastPaymentsPage from "./PastPayments";
import PlanDetailsPage from "./PlansDetails";
import "./Subscription.css";
import { DynamicContext } from "../../../Context/DynamicContext";
import {
  GET_ALL_PLANS_DETAILS,
  VYLABS_BASE_URL,
  UPDATE_SUBSCRIPTION_PLAN,
} from "../../../helper/url_helper";
import { get, post } from "../../../helper/Api_helper";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations";
import Button from "../../../Common/Button/Button";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar";
import { TENANT_OTP_API_KEY } from "../../../Tenant-Config/TenantConfig";

function Subscription({ initialTab }) {
  const [activeTab, setActiveTab] = useState("Billings");
  const { hasSubscription, subscriptionDetails } = useContext(DynamicContext);
  const [plansData, setPlansData] = useState([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(false);
  const isManualBilling = subscriptionDetails?.billing_provider === "manual";

  const handleUpdatePlan = async () => {
    try {
      const response = await post(VYLABS_BASE_URL, UPDATE_SUBSCRIPTION_PLAN);
      if (response && response.portal_session_url) {
        window.location.href = response.portal_session_url;
      } else {
        console.error("No portal session URL received");
        Toast("error", "Failed to get portal session URL");
      }
    } catch (error) {
      console.error("Error updating subscription plan:", error);
      Toast("error", error.message || "An error occurred");
    }
  };

  const getAllPlanDetails = async () => {
    try {
      setIsLoadingPlans(true);
      const response = await get(VYLABS_BASE_URL, GET_ALL_PLANS_DETAILS,
        {
          _skipAuth: true, 
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        },
      );
      if (response && response.plans) {
        setPlansData(response.plans);
      }
    } catch (error) {
      console.log("getAllPlanDetails", error);
    } finally {
      setIsLoadingPlans(false);
    }
  };

  useEffect(() => {
    getAllPlanDetails();
  }, []);

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  useEffect(() => {
    if (!hasSubscription && activeTab === "Billings") {
      setActiveTab("Plan Details");
    }
  }, [hasSubscription, activeTab, isManualBilling]);

  const renderContent = () => {
    switch (activeTab) {
      case "Billings":
        return hasSubscription ? (
          <BillingsPage
            plansData={plansData}
            isManualBilling={isManualBilling}
          />
        ) : (
          <PlanDetailsPage
            plansData={plansData}
            isManualBilling={isManualBilling}
          />
        );
      case "Plan Details":
        return isLoadingPlans ? (
          <div className="loading-animation">
            <VybogTALLoaderAnimation />
          </div>
        ) : (
          <PlanDetailsPage
            plansData={plansData}
            isManualBilling={isManualBilling}
          />
        );
      default:
          return hasSubscription ? (
          <BillingsPage />
        ) : (
          <PlanDetailsPage
            plansData={plansData}
            isManualBilling={isManualBilling}
          />
        );
    }
  };

  const renderHeader = () => {
    switch (activeTab) {
      case "Billings":
        return "Billing";
      case "Past Payments":
        return "Past Payments";
      case "Plan Details":
        return isManualBilling ? "Plan Details" : "View Plans";
      default:
        return !isManualBilling && hasSubscription ? "Billing" : "Plan Details";
    }
  };

  const renderSubHeader = () => {
    switch (activeTab) {
      case "Billings":
        return "View and manage your subscription and payment methods.";
      case "Past Payments":
        return "Track your transaction history and invoices.";
      case "Plan Details":
        return isManualBilling
          ? "Here are the details of your current plan."
          : "Explore and upgrade your subscription options.";
      default:
        return !isManualBilling && hasSubscription
          ? "View and manage your subscription and payment methods."
          : "Here are the details of your current plan.";
    }
  };

  return (
    <>
      <div className="subscription-header">
        <div className="settings-title-container">
          <h2 className="subscription-title">{renderHeader()}</h2>
          <p className="subscription-subtitle">{renderSubHeader()}</p>
        </div>
      </div>
      {activeTab === "Plan Details" && !isManualBilling && hasSubscription && (
        <div className="header-button-container">
          <Button
            label="Manage Subscription"
            event={handleUpdatePlan}
            style={{ marginLeft: "auto" }}
          />
        </div>
      )}
        <div className="tabs-container">
          {hasSubscription && (
            <div
              className={`tab ${
                activeTab === "Billings" ? "subscription-tab-active" : ""
              }`}
              onClick={() => setActiveTab("Billings")}
            >
              {isManualBilling ? "Current Plan" : "Billing"}
            </div>
          )}

          {/* <div
            className={`tab ${
              activeTab === "Past Payments" ? "subscription-tab-active" : ""
            }`}
            onClick={() => setActiveTab("Past Payments")}
          >
            Past Payments
          </div> */}

          <div
            className={`tab ${
              activeTab === "Plan Details" ? "subscription-tab-active" : ""
            }`}
            onClick={() => setActiveTab("Plan Details")}
          >
            View Plans
          </div>
        </div>
      <div className="content-container">{renderContent()}</div>
    </>
  );
}

export default Subscription;